/**
 * @generated SignedSource<<f06a169e0e18b6110b6dc516696f18c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeliveryOrderXlsxImportInput = {
  commit: boolean;
  file: Upload;
};
export type Upload = {
  fieldName?: string | null;
  key: string;
  multipartUploadResult?: MultiPartUploadResult | null;
  objectUrl?: string | null;
  size: number;
};
export type MultiPartUploadResult = {
  partPairs: ReadonlyArray<PartPair>;
  uploadId: string;
};
export type PartPair = {
  ETag: string;
  PartNumber: number;
};
export type DeliveryOrderXlsxImportDialog_deliveryOrderXlsxImportMutation$variables = {
  input: DeliveryOrderXlsxImportInput;
};
export type DeliveryOrderXlsxImportDialog_deliveryOrderXlsxImportMutation$data = {
  readonly deliveryOrderXlsxImport: {
    readonly committed: boolean;
    readonly issues: ReadonlyArray<{
      readonly field: string;
      readonly kind: string;
      readonly message: string;
      readonly row: number;
    }>;
    readonly readByHeader: boolean;
    readonly totalCount: number;
    readonly updatedCount: number;
    readonly validCount: number;
  };
};
export type DeliveryOrderXlsxImportDialog_deliveryOrderXlsxImportMutation = {
  response: DeliveryOrderXlsxImportDialog_deliveryOrderXlsxImportMutation$data;
  variables: DeliveryOrderXlsxImportDialog_deliveryOrderXlsxImportMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeliveryOrderXlsxImportResult",
    "kind": "LinkedField",
    "name": "deliveryOrderXlsxImport",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "committed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "readByHeader",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "validCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DeliveryOrderXlsxIssue",
        "kind": "LinkedField",
        "name": "issues",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "row",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "kind",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeliveryOrderXlsxImportDialog_deliveryOrderXlsxImportMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeliveryOrderXlsxImportDialog_deliveryOrderXlsxImportMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "00e838b0b89cd9ea1a2353744a744ab0",
    "id": null,
    "metadata": {},
    "name": "DeliveryOrderXlsxImportDialog_deliveryOrderXlsxImportMutation",
    "operationKind": "mutation",
    "text": "mutation DeliveryOrderXlsxImportDialog_deliveryOrderXlsxImportMutation(\n  $input: DeliveryOrderXlsxImportInput!\n) {\n  deliveryOrderXlsxImport(input: $input) {\n    committed\n    readByHeader\n    totalCount\n    validCount\n    updatedCount\n    issues {\n      row\n      kind\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a4022314941f8be3577fe78753c5aa1a";

export default node;
